import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

// 从 localStorage获取保存的语言
const savedLanguage = localStorage.getItem('lang') || 'zh'

i18n
    // .use(LanguageDetector)  // 自动检测浏览器语言
    .use(Backend)               // 动态加载语言包
    .use(initReactI18next)   // 注入React集成
    .init({
        lng: savedLanguage,     // 语言
        fallbackLng: 'zh',     // 默认语言
        ns: ['translations'],  // 命名空间
        defaultNS: 'translations',
        interpolation: {
            escapeValue: false   // XSS防护
        },
        backend: {
            loadPath: (process.env.PUBLIC_URL || '') + '/locales/{{lng}}.json'  // 语言包路径
        }
    });

// 导出切换语言的函数
export const changeLanguage = async (lang) => {
    return i18n.changeLanguage(lang)
}

// 导出获取当前语言的函数
export const getCurrentLanguage = () => {
    return i18n.language
}